import {
  LayoutDashboard,
  Users,
  UserCheck,
  CalendarDays,
  UsersRound,
  ShieldAlert,
  MessagesSquare,
  Building2,
  LifeBuoy,
  FileCheck2,
  Bell,
  BarChart3,
  ScrollText,
  Activity,
  Settings,
  Layers,
  ListChecks,
  ShieldCheck,
  HelpCircle,
} from "lucide-react";

// The full, binding Control OS main menu. Which entries a role sees is decided by MENU_PERMISSION in backend/rbac.py.
// "built: true" pages are functional in this preview phase.
export const MENU_ITEMS = [
  { key: "overview", path: "/", icon: LayoutDashboard, built: true },
  { key: "tasks", path: "/aufgaben", icon: ListChecks, built: true },
  { key: "both_apps", path: "/beide-apps", icon: Layers, built: true },
  { key: "members", path: "/mitglieder", icon: Users, built: true },
  { key: "reviews", path: "/profilpruefungen", icon: UserCheck, built: true },
  { key: "activities", path: "/aktivitaeten", icon: CalendarDays, built: true },
  { key: "groups", path: "/kreise-gruppen", icon: UsersRound, built: true },
  { key: "reports", path: "/meldungen-sicherheit", icon: ShieldAlert, built: true },
  { key: "community", path: "/community-beitraege", icon: MessagesSquare, built: true },
  { key: "organizations", path: "/organisationen", icon: Building2, built: false },
  { key: "support", path: "/support", icon: LifeBuoy, built: false },
  { key: "content", path: "/inhalte-freigaben", icon: FileCheck2, built: false },
  { key: "notifications", path: "/benachrichtigungen", icon: Bell, built: false },
  { key: "pilot", path: "/pilot-auswertung", icon: BarChart3, built: true },
  { key: "audit", path: "/audit-log", icon: ScrollText, built: true },
  { key: "system", path: "/systemstatus", icon: Activity, built: false },
  { key: "team", path: "/team-rechte", icon: ShieldCheck, built: true },
  { key: "settings", path: "/einstellungen", icon: Settings, built: false },
  { key: "help", path: "/hilfe", icon: HelpCircle, built: true },
];
